import { ReactNode } from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { fonts, colors } from 'components/styles/variables';

interface ThemeProviderWrapperProps {
  children: ReactNode;
}

export const theme = createTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  typography: {
    fontFamily: fonts.default,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 850,
      lg: 1200,
      xl: 1920,
    },
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: 'white',
      },
    },
  },
  palette: {
    primary: {
      main: colors.ALR1,
    },
  },
});

function ThemeProviderWrapper({ children }: ThemeProviderWrapperProps): JSX.Element {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default ThemeProviderWrapper;
